/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Fund_CreatingInputs */

const en_onboarding_v1_fund_creating = /** @type {(inputs: Onboarding_V1_Fund_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating your portfolio…`)
};

const de_onboarding_v1_fund_creating = /** @type {(inputs: Onboarding_V1_Fund_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portfolio wird erstellt…`)
};

const pt_br2_onboarding_v1_fund_creating = /** @type {(inputs: Onboarding_V1_Fund_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criando seu portfólio…`)
};

const tr_onboarding_v1_fund_creating = /** @type {(inputs: Onboarding_V1_Fund_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portföyün oluşturuluyor…`)
};

const zh_cn2_onboarding_v1_fund_creating = /** @type {(inputs: Onboarding_V1_Fund_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在创建投资组合…`)
};

const zh_hk2_onboarding_v1_fund_creating = /** @type {(inputs: Onboarding_V1_Fund_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在建立投資組合…`)
};

const ko_kr2_onboarding_v1_fund_creating = /** @type {(inputs: Onboarding_V1_Fund_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`포트폴리오를 만드는 중…`)
};

const ru_ru2_onboarding_v1_fund_creating = /** @type {(inputs: Onboarding_V1_Fund_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создаём портфель…`)
};

const es_419_onboarding_v1_fund_creating = /** @type {(inputs: Onboarding_V1_Fund_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creando tu portafolio…`)
};

/**
* | output |
* | --- |
* | "Creating your portfolio…" |
*
* @param {Onboarding_V1_Fund_CreatingInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_fund_creating = /** @type {((inputs?: Onboarding_V1_Fund_CreatingInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Fund_CreatingInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_fund_creating(inputs)
	if (locale === "de") return de_onboarding_v1_fund_creating(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_fund_creating(inputs)
	if (locale === "tr") return tr_onboarding_v1_fund_creating(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_fund_creating(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_fund_creating(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_fund_creating(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_fund_creating(inputs)
	return es_419_onboarding_v1_fund_creating(inputs)
});